import { useContext, useEffect } from 'react';

import { Store } from '@src/store';
import { setDraftLS } from '@src/utils';

export const useIflHouseDraft = () => {
  const {
    state: {
      stateFormIFLHouse: {
        selectedIProduct,
        selectedRegion,
        regions,
        risks,
        insuranceSubproducts,
        insuranceSum,
        getPrices,
        getPricesFull,
        selectedDuration,
        selectedDate,
        dadaValue,
        promoCode,
        promoCodeApplyed,
        risksPage,
        materials,
        selectedBuildingMaterialCode,
        fieldWithEmptyDependencies,
        emptyDependencies,
        isObjectDataError,
        getSubobjectsRefetchUid,
        isSelectedCustomStreet,
        isSelectedCustomHouse,
        isEmptyStreetSuggestions,
        isEmptyHouseSuggestions,
        presetData,
        isHouseNotFound,
      },
      stateFormIFLHouse,
      stateUser: { profile, selectedProduct, agentLogin },
      stateWizard: { currentStep },
    },
  } = useContext(Store);

  useEffect(() => {
    if (!agentLogin && !presetData) {
      const data = {
        dataObject: {
          ...stateFormIFLHouse,
          promoCode: promoCodeApplyed && promoCode,
        },
        profile,
        selectedProduct,
        currentStep: currentStep || 0,
      };
      setDraftLS(data);
    }
  }, [
    selectedIProduct,
    selectedRegion,
    regions,
    risks,
    insuranceSubproducts,
    insuranceSum,
    getPrices,
    getPricesFull,
    selectedDuration,
    selectedDate,
    dadaValue,
    promoCode,
    promoCodeApplyed,
    risksPage,
    materials,
    selectedBuildingMaterialCode,
    fieldWithEmptyDependencies,
    emptyDependencies,
    isObjectDataError,
    getSubobjectsRefetchUid,
    isSelectedCustomStreet,
    isSelectedCustomHouse,
    isEmptyStreetSuggestions,
    isEmptyHouseSuggestions,
    presetData,
    agentLogin,
    isHouseNotFound,
  ]);

  return;
};
